<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JhBLyA/tc-custom/9781429945301.jpg?1735615087438" alt="This image is the cover for the book Rival to the Queen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rival to the Queen
      </h1>
      <p class="bookDescription body article font2">
        <b>“An exquisitely realistic portrait of Tudor England” sets the stage for royal romantic rivalry in this “compelling” novel from a <i>New York Times</i> bestseller (<i>Library Journal</i>).</b><br/><br/>From the <i>New York Times–</i>bestselling author of <i>The Last Wife of Henry VIII</i> comes a novel about the rivalry between Queen Elizabeth I and her cousin, Lettice Knollys, for the love of one extraordinary man.<br/><br/>Powerful, dramatic and full of the rich history that has made Carolly Erickson’s novels perennial bestsellers, this is the story of the only woman to ever stand up to the Virgin Queen—her own cousin, Lettie Knollys. Far more attractive than the queen, Lettie soon won the attention of the handsome and ambitious Robert Dudley, Earl of Leicester, a man so enamored of the queen and determined to share her throne that it was rumored he had murdered his own wife in order to become her royal consort. The enigmatic Elizabeth allowed Dudley into her heart, and relied on his devoted service, but shied away from the personal and political risks of marriage.<br/><br/>When Elizabeth discovered that he had married her cousin Lettie in secret, Lettie would pay a terrible price, fighting to keep her husband’s love and ultimately losing her beloved son, the Earl of Essex, to the queen’s headsman.<br/><br/>This is the unforgettable story of two women related by blood, yet destined to clash over one of Tudor England’s most charismatic men.<br/><br/>“<i>Rival to the Queen</i> gives this forgotten woman a place in history.” —<i>RT Book Reviews</i><br/><br/>“If you are a fan of Carolly Erickson or historical fiction, this book is for you.” —<i>Affaire de Coeur</i><br/><br/>“Erickson writes gracefully.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carolly Erickson
      </h2>
      
      <p class="authorDescription body article"><P>Distinguished historian <B>Carolly Erickson</B> is the author of <I>The Memoirs of Mary Queen of Scots, The First Elizabeth, The Hidden Life of Josephine, The Last Wife of Henry VIII</I>, and many other prize-winning works of fiction and nonfiction. Her novel <I>The Tsarina's Daughter</I> won the <I>Romantic Times</I> Reviewer's Choice Award for Best Historical Fiction. She lives in Hawaii.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65fd0b30